export * from './interface';

export { default } from './tooltip';
